// File: src/Hooks/GetSupportModalApi/useGetTicketDetails.ts
import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

export interface Message {
  id: string;
  text: string;
  from: 'left' | 'right';
  user: string;
}

export interface TicketDetails {
  id: number;
  title: string;
  status: 'Resolved' | 'In progress' | 'Not Seen';
  category: string;
  created_at: string;
  last_updated: string;
  user_unread_count: number;
  messages: Message[];
}

interface ApiResponse {
  status: 'success' | 'error';
  data: TicketDetails;
}

export function useGetTicketDetails(id?: number | string, enabled = true) {
  return useQuery({
    enabled: !!id && enabled,
    queryKey: ['ticketDetails', id],
    queryFn: async (): Promise<TicketDetails> => {
      const token = await getLocalStorage('access_token');
      const response = await ChessRestClient.get<ApiResponse>(
        `/user_raised_issues/ticket/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );

      if (response.data.status !== 'success') {
        throw new Error('Failed to fetch ticket details');
      }

      return response.data.data;
    },
    // staleTime: 1000 * 60 * 2,
    // refetchOnWindowFocus: false,
  });
}
